import i18n from '@/plugins/i18n';

function getAnnouncementColumns(handlers) {
  return getColumns(handlers, announcementColumns);
}

function getMemberNewsColumns(handlers) {
  return getColumns(handlers, memberNewsColumns);
}

function getHomepageContentColumns(handlers) {
  return getColumns(handlers, homepageContentColumns);
}

function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const announcementColumns = [
  {
    text: i18n.t("label.title"),
    value: "title",
    sortBy: "title",
    type: "text",
  },
  {
    text: i18n.t("label.created_at"),
    value: "created_at",
    sortBy: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "edit",
        color: "primary",
        key: "edit",
        handler: null,
      },
      {
        icon: "cancel",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

const memberNewsColumns = [
  {
    text: i18n.t("label.title"),
    value: "title",
    sortBy: "title",
    type: "text",
  },
  {
    text: i18n.t("label.writer"),
    value: "member",
    subField: "name",
    type: "text",
  },
  {
    text: i18n.t("label.created_at"),
    value: "created_at",
    sortBy: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "description",
        color: "primary",
        key: "description",
        handler: null,
      },
      {
        icon: "cancel",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

const homepageContentColumns = [
  {
    text: i18n.t("label.title"),
    value: "title",
    type: "text",
  },
  {
    text: i18n.t("label.updated_at"),
    value: "updated_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "edit",
        color: "primary",
        key: "edit",
        handler: null,
      },
    ],
  },
];

export {
  getAnnouncementColumns,
  getMemberNewsColumns,
  getHomepageContentColumns,
};
